import validate from 'validate.js'

const constraints = {
  updatedCountry: {
    presence: true
  },
  countryId: {
    presence: true
  }
}

export default (data) => {
  return validate(data, constraints)
}
